import CommonError from '../Common/CommonError'
import { error503 } from '../ErrorSvg'

const Error503Container = () => {
  return (
    <CommonError src={error503} />
  )
}

export default Error503Container